import React from 'react';
import * as AppleAuthentication from 'expo-apple-authentication';
import { processLoginAccount } from '../utils/Functions';
import UserState from '../src/contexts/UserState';
import Storage from '../components/Storage';
import { useLinkTo } from '@react-navigation/native';

export default function AppleAuthButton(props) {
  const [user, setUser] = React.useContext(UserState);
  const linkTo = useLinkTo();

  const appleLogin = async () => {
    try {
      if(props.setLoginType){
        props.setLoginType('Apple');
      }
      const credential = await AppleAuthentication.signInAsync({
        requestedScopes: [
          AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
          AppleAuthentication.AppleAuthenticationScope.EMAIL,
        ],
      });
      console.log('apple credential',credential);
      // signed in
      let appleUser = {
        email: credential.email || null,
        name: getName(credential.fullName),
        avatar: null,
        type: 'Apple',
        id: credential.user,
        token: credential.identityToken,
        authCode: credential.authorizationCode,
      };
      props.setSocialUser(appleUser);
      try {
        let apiLoginResult = await props.socialApiLogin(appleUser, 'apple');
        // let apiLoginResult = await props.socialApiLogin('apple');
        console.log('apiLoginResult', apiLoginResult);
        if (apiLoginResult.result) {
          let user = processLoginAccount(apiLoginResult.session.account, true);
          checkUsernameSecureStore(user, appleUser);
          // props.setUser(user);
          // props.setLoggedIn(true);
        } else {
          if (apiLoginResult.MFA) {
            props.setShowMFA(true);
            props.setMFARequired(true);
          } else {
            if (apiLoginResult.errors) {
              console.log(apiLoginResult.errors.join('; '));
            }
            props.navigation.navigate('SignUp', { socialUser: appleUser });
          }
        }
      } catch (err) {
        console.log('apple auth apiLoginResult catch: ', err);
      }
    } catch (e) {
      if (e.code === 'ERR_CANCELED') {
        // handle that the user canceled the sign-in flow
      } else {
        // handle other errors
      }
    }
  }
  const checkUsernameSecureStore = async (user, socialUser) => {
    // const delU = SecureStore.deleteItemAsync('username');
    // const delP = SecureStore.deleteItemAsync('password');
    // const setA = SecureStore.setItemAsync('useLocalAuthentication', 'no');const uname = await Storage.getItem('username');
    
    const socialId = await Storage.getItem('socialId');
    console.log('checkUsernameSecureStore', socialId);
    if (!socialId || (socialId !== socialUser.id)) {
      console.log('deleting useLocalAuthentication');
      await Storage.removeItem('useLocalAuthentication');
    }
    console.log('social checkUserNameSecureStore: ', user, socialUser);
    const setS = Storage.setItem('socialId', socialUser.id);
    const delU = Storage.removeItem('username');
    const delP = Storage.removeItem('password');
    await Promise.all([setS, delU, delP])

    setUser(user);

    if (!user.terms_of_use) {
      linkTo('/acceptterms?signUp=yes');
    }

    return true;
  }

  const getName = (fullName) => {
    if(fullName.givenName){
      if(fullName.familyName){
        return fullName.givenName + ' ' + fullName.familyName;
      }
      return fullName.givenName;
    }
    return null;
  }

  return (
    <AppleAuthentication.AppleAuthenticationButton
      buttonType={AppleAuthentication.AppleAuthenticationButtonType.SIGN_IN}
      buttonStyle={AppleAuthentication.AppleAuthenticationButtonStyle.WHITE}
      cornerRadius={5}
      style={{ width: '100%', height: 40 }}
      onPress={() => appleLogin()}
    />
  );
}